import React, { useEffect, useState } from 'react';
import { RunSummary, listReplacementRuns } from '../../../api/cafAutomation';
import { Drawer } from '../Overlay';
import { AutomationRunDrawer, replacementRunLabel } from './AutomationRunDrawer';

export const AutomationRunsDrawer: React.FC<{ attention?: boolean; workflowId?: string; onClose: () => void }> =
  ({ attention = false, workflowId, onClose }) => {
    const [items, setItems] = useState<RunSummary[]>([]);
    const [cursor, setCursor] = useState<string | null>(null);
    const [selected, setSelected] = useState<string | null>(null);
    const [status, setStatus] = useState('');
    const [busy, setBusy] = useState(false);
    const [problem, setProblem] = useState('');
    const [refresh, setRefresh] = useState(0);
    useEffect(() => {
      let active = true;
      setBusy(true);
      listReplacementRuns({ workflow: workflowId, status: status || undefined }, attention).then((page) => {
        if (active) { setItems(page.items); setCursor(page.next_cursor); setProblem(''); setBusy(false); }
      }, () => { if (active) { setProblem("Couldn't load workflow runs."); setBusy(false); } });
      return () => { active = false; };
    }, [attention, workflowId, status, refresh]);
    const more = async () => {
      if (!cursor || busy) return;
      setBusy(true);
      try {
        const page = await listReplacementRuns({ workflow: workflowId, status: status || undefined, cursor }, attention);
        setItems((old) => [...old, ...page.items]); setCursor(page.next_cursor); setProblem('');
      } catch { setProblem("Couldn't load more runs."); }
      finally { setBusy(false); }
    };
    return <>
      <Drawer eyebrow="Automation" title={attention ? 'Needs attention' : 'Workflow runs'} onClose={onClose}
        footer={<button type="button" className="ui-btn ui-btn--ghost ui-btn--md" onClick={onClose}>Close</button>}>
        {!attention && <label>Status <select value={status} onChange={(event) => setStatus(event.target.value)}>
          <option value="">All</option><option value="ready">Working</option><option value="waiting">Waiting</option>
          <option value="held">Held</option><option value="failed">Failed</option><option value="completed">Finished</option>
          <option value="unknown_external_outcome">Send outcome unknown</option><option value="pending_reconciliation">Checking sent</option>
        </select></label>}
        <button type="button" className="cur-linkish" onClick={() => setRefresh((value) => value + 1)}>Refresh</button>
        {problem && <p role="alert">{problem}</p>}
        {!items.length && !busy && !problem && <p>No runs here.</p>}
        <ul className="cur-wf-rows">{items.map((item) => <li key={item.run_id}>
          <button type="button" className="cur-linkish" onClick={() => setSelected(item.run_id)}>
            {item.name || 'Workflow'} · version {item.version} · {replacementRunLabel(item)}
          </button>
          {item.source?.label && <span className="cur-small"> · {item.source.label}</span>}
        </li>)}</ul>
        {busy && <p role="status">Loading…</p>}
        {cursor && <button type="button" className="ui-btn ui-btn--secondary ui-btn--sm" disabled={busy} onClick={() => { void more(); }}>Load more</button>}
      </Drawer>
      {selected && <AutomationRunDrawer runId={selected} onClose={() => setSelected(null)}
        onChanged={() => setRefresh((value) => value + 1)} />}
    </>;
  };
